// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__rS1ky","preloader":"Loading_preloader__5FJvu","centered":"Loading_centered__d1sRK"};